import { useResetPasswordMutation } from '../../apis/passwordApi';
import { useNextQueryStringValue } from '../useQueryString';
import { useUsername } from '../useUsersSlice';
import { VerifiedPasswordResetRequest } from '../../types';
import { useCallback, useEffect, useState } from 'react';
import { AlertType, TowerAlert } from '../../../../common/Alerts';
import useRedirectOrCloseOnSuccess from '../useRedirectOrCloseOnSuccess';

const useReset = () => {
    const { username } = useUsername();
    const next = useNextQueryStringValue();

    const [resetPasswordMutation, { data, isLoading, isError, error, reset: resetMutation }] =
        useResetPasswordMutation();

    // Redirect or close the window on successful password reset
    useRedirectOrCloseOnSuccess(data?.redirectUrl as string);

    const [alerts, setAlerts] = useState<TowerAlert[]>([]);

    // show error alert on failure
    useEffect(() => {
        if (isError) {
            const msg = (error as any)?.data || '';
            const match = msg.match(/"([^"]+)"/);

            const message = match ? match[1] : 'Error processing your request.';
            setAlerts([{ type: AlertType.error, message }]);
        }
    }, [isError, error]);

    const resetPassword = useCallback(
        (password: string, code: string) => {
            if (isLoading) return;

            setAlerts([]);
            resetPasswordMutation({
                username,
                password,
                verificationRequest: { email: username, code },
                next,
            } as VerifiedPasswordResetRequest & { next?: string });
        },
        [isLoading, resetPasswordMutation, username, next]
    );

    const reset = useCallback(() => {
        setAlerts([]);
        resetMutation();
    }, [resetMutation]);

    return {
        resetPassword,
        isLoading,
        alerts,
        reset,
    };
};
export default useReset;
